import { useState } from "react";
import { formatJson } from "../../../../lib/types";
import { subclasseSelect, classeSelect, grupoSelect, divisaoSelect, secaoSelect } from "../../../../config/data";
import SelectBasic from "../../../form/SelectBasic";
import { usePostHog } from "posthog-js/react";
import { Col, Row } from "antd";
import SocialFilter from "../social";

const filterOptions = [
  { label: 'Subclasse', value: 'subclasse' },
  { label: 'Classe',    value: 'classe'    },
  { label: 'Grupo',     value: 'grupo'     },
  { label: 'Divisão',   value: 'divisao'   },
  { label: 'Seção',     value: 'secao'     }
];

const aiOptions = [
  { label: 'Subclasse', value: 'subclasse' },
  { label: 'Grupo',     value: 'grupo'     }
];

const socialOptions = [
  {label: 'Site', value:'site'},
  {label: 'Facebook', value:'facebook'},
  {label: 'WhatsApp', value:'whatsapp'},
  {label: 'LinkedIn', value:'linkedin'},
  {label: 'Instagram', value:'instagram'}
]

export default function ActivitiesFilter({ onChange, aiGeneration = false }: any) {
  const [subclasse, setSubclasse] = useState<string[] | string>([]);
  const [classe,    setClasse]    = useState<string[] | string>([]);
  const [grupo,     setGrupo]     = useState<string[] | string>([]);
  const [divisao,   setDivisao]   = useState<string[] | string>([]);
  const [secao,     setSecao]     = useState<string[] | string>([]);
  const [level,     setLevel]     = useState<string>('');
  const [social,    setSocial]    = useState<string[]>([])
  const posthog = usePostHog();

  const formatOptions = (options: Array<formatJson>) => 
    options
      .sort((a, b) => parseInt(a.value) - parseInt(b.value))
      .map(({ value, label }) => ({ value, label: `${value} - ${label}` }));

  const formatOptionsLetters = (options: Array<formatJson>) => 
    options
      .sort((a, b) => a.value.localeCompare(b.value))
      .map(({ value, label }) => ({ value, label: `${value} - ${label}` }));

  const handleChange = (field: string, value: any) => onChange(field, value);

  const isAnySelected = 
    !!subclasse.length || !!classe.length || !!grupo.length || !!divisao.length || !!secao.length;

  return (
    <div className={aiGeneration ? "aiGenerationActivityFilter" : "lead-genenation-filter-wrapper"}>
      <Row gutter={[16, 16]} style={{display:'flex', justifyContent: 'flex-start'}}>
        <Col span={aiGeneration ? 0 : 3}/>
        <Col span={aiGeneration ? 12 : 7}>
          <SelectBasic
            name="level"
            label="Nível"
            options={aiGeneration ? aiOptions : filterOptions}
            value={level}
            onChange={(value) => {
              posthog.capture('selecionar_nivel_atividade_select', { level: value });
              setLevel(value.toString());
            }}
            disabled={isAnySelected && !subclasse.length}
          />
        </Col>
        <Col span={aiGeneration ? 0 : 2}/>
        <Col span={ aiGeneration ? 12 : 7}>
          {level === 'subclasse' && (
            <SelectBasic
              name="subclasse"
              label="Atividade"
              mode="multiple"
              expandDropdown
              options={formatOptions(subclasseSelect)}
              value={subclasse}
              onChange={(value) => {
                posthog.capture('selecionar_subclasse_atividade_select');
                setSubclasse(value);
                handleChange('subclasse', value);
              }}
              disabled={isAnySelected && !subclasse.length}
            />
          )}
          {level === 'classe' && (
            <SelectBasic
              name="classe"
              label="Atividade"
              mode="multiple"
              expandDropdown
              options={formatOptions(classeSelect)}
              value={classe}
              onChange={(value) => {
                posthog.capture('selecionar_classe_atividade_select');
                setClasse(value);
                handleChange('classe', value);
              }}
              disabled={isAnySelected && !classe.length}
            />
          )}
          {level === 'grupo' && (
            <SelectBasic
              name="grupo"
              label="Atividade"
              mode="multiple"
              expandDropdown
              options={formatOptions(grupoSelect)}
              value={grupo}
              onChange={(value) => {
                posthog.capture('selecionar_grupo_atividade_select');
                setGrupo(value);
                handleChange('grupo', value);
              }}
              disabled={isAnySelected && !grupo.length}
            />
          )}
          {level === 'divisao' && (
            <SelectBasic
              name="divisao"
              label="Atividade"
              mode="multiple"
              expandDropdown
              options={formatOptions(divisaoSelect)}
              value={divisao}
              onChange={(value) => {
                posthog.capture('selecionar_divisao_atividade_select');
                setDivisao(value);
                handleChange('divisao', value);
              }}
              disabled={isAnySelected && !divisao.length}
            />
          )}
          {level === 'secao' && (
            <SelectBasic
              name="secao"
              label="Atividade"
              mode="multiple"
              expandDropdown
              options={formatOptionsLetters(secaoSelect)}
              value={secao}
              onChange={(value) => {
                posthog.capture('selecionar_secao_atividade_select');
                setSecao(value);
                handleChange('secao', value);
              }}
              disabled={isAnySelected && !secao.length}
            />
          )}
          {level === '' && (
            <SelectBasic
              name="emptyHolder"
              label="Atividade"
              mode="multiple"
              expandDropdown
              options={[]}
              value={[]}
              disabled
            />
          )}
        </Col>
        <Col span={aiGeneration ? 0 : 3}/>
      </Row>
      <Row gutter={[16, 16]} style={{display: aiGeneration ? 'none': 'flex', justifyContent: 'space-between'}}>
          <SocialFilter onChange={onChange}/>
      </Row>
      <span  style={{display: aiGeneration ? 'none': 'inherit'}} className="lead-genenation-filter-wrapper-footer">Não é necessário preencher todos os campos ou filtros</span>
    </div>
  );
}
